let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iBVwV")).then(() => parcelRequire('kZ5TM'));